import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './boon.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { Formik } from 'formik';
import { Card, Col, Row, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { checkDuplicateName } from '~/utils/validators.yup';
import { API_PREFIX } from './boon.api';
import ActiveRounds from '../components/ActiveRounds';
import ActiveTurns from '../components/ActiveTurns';
import { BasicInfo, DVandPoint, BonusAndDamage, HealthPoint } from './FormGroup';
import { FormCombo, FormNumber, FormSelect } from '~/components/FormControl';
import { fetchCardMetaDataApi } from '../../CardSaga/cardMetaDataSlice';
import startCase from 'lodash/startCase';

export const maxLimit = 2;
function BoonForm({ initialValues, setResetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const { statuses } = cardMetaData;
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(statuses)) dispatch(fetchCardMetaDataApi());
    }, []);

    const [negOptions, posOptions] = React.useMemo(() => createOptions(), []);

    return (
        <>
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={schema}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm } = props;
                                const asyncApiCall = checkDuplicateName(initialValues.name, API_PREFIX);
                                // eslint-disable-next-line react/prop-types

                                return (
                                    <div className="mr-3">
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Row>
                                            <Col
                                                sm={4}
                                                className="d-flex"
                                            >
                                                <BasicInfo asyncApiCall={asyncApiCall} />
                                            </Col>
                                            <Col sm={8}>
                                                {/* {'1st row'} */}
                                                <Row>
                                                    <DVandPoint
                                                        negOptions={negOptions}
                                                        posOptions={posOptions}
                                                    />
                                                </Row>

                                                {/* {'2nd row'} */}
                                                <Row>
                                                    <HealthPoint
                                                        negOptions={negOptions}
                                                        posOptions={posOptions}
                                                    />
                                                </Row>
                                                {/* {'2nd row'} */}
                                                <Row>
                                                    <BonusAndDamage
                                                        negOptions={negOptions}
                                                        posOptions={posOptions}
                                                    />
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <ActiveRounds
                                                smCol={4}
                                                smCheckbox={4}
                                            />
                                            <ActiveTurns
                                                smCol={4}
                                                className="justify-content-around"
                                            />
                                        </Row>

                                        <BoonEffects
                                            name="effects"
                                            title={startCase('effects')}
                                            options={statuses || []}
                                        />

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </div>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

const withFormCombo = (FormCombo) => {
    // eslint-disable-next-line react/prop-types, react/display-name
    return ({ name, title, options }) => {
        const renderFunc = (index, defaultValue1) => {
            return (
                <Form.Row>
                    <FormSelect
                        name={`${[name]}.${index}.status`}
                        label={title}
                        options={options}
                        defaultValue={defaultValue1}
                        sm={6}
                    />
                    <FormNumber
                        name={`${[name]}.${index}.statusVal`}
                        label={'Value'}
                        sm={6}
                    />
                </Form.Row>
            );
        };

        return (
            <FormCombo
                sm={4}
                name={name}
                headerClass="bg-info"
                renderFunc={renderFunc}
                options={options}
                title={startCase('effects')}
                valueObj={{
                    status: '',
                    statusVal: '',
                }}
                wrapperClass="mt-3"
            ></FormCombo>
        );
    };
};

function createOptions() {
    let negOptions = [];
    for (let i = -100; i <= -1; i++) {
        negOptions.push({
            id: i,
            name: i,
        });
    }

    let posOptions = [];
    for (let i = 0; i <= 100; i++) {
        posOptions.push({
            id: i,
            name: i,
        });
    }

    return [negOptions, posOptions];
}

BoonForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

const BoonEffects = withFormCombo(FormCombo);

export default BoonForm;
